import React, { useRef, useCallback, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import {
  ButtonGroup
} from 'react-bootstrap'
import Button from 'components/Button'
import KanBoIcon from 'components/KanBoIcon'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import UserGroupPicker from 'components/UserGroupPicker'

export function AddUserGroup ({
  layoutId,
  permissionLevel,

  permission,

  requestSetUserGroupPermissionInHomeLayout,

  leftSidebar
}) {
  const userGroupPickerRef = useRef(null)

  useEffect(() => {
    if (!permission.owner) {
      leftSidebar.pop()
    }
  }, [permission.owner, leftSidebar])

  const handleAddUserGroupClick = useCallback(() => {
    const selectedUserGroups = userGroupPickerRef.current.getSelectedUserGroups()

    selectedUserGroups.forEach(({ id }) => {
      requestSetUserGroupPermissionInHomeLayout({
        layoutId,
        userGroupId: id,
        permissionLevel
      })
    })

    leftSidebar.pop()
  }, [layoutId, permissionLevel, requestSetUserGroupPermissionInHomeLayout, leftSidebar])

  const handleCancelClick = useCallback(() => {
    leftSidebar.pop()
  }, [leftSidebar])

  return (
    <LeftSidebarView
      title={<FormattedMessage id='USER_GROUP_ADD' />}
    >
      <UserGroupPicker
        ref={userGroupPickerRef}
      />
      <ViewBody className='p-10'>
        <ButtonGroup>
          <Button
            bsStyle='primary'
            icon={<KanBoIcon name='kanbo-16-plus' />}
            onClick={handleAddUserGroupClick}
          >
            <FormattedMessage id='ADD_SELECTED' />
          </Button>
          <Button onClick={handleCancelClick}>
            <FormattedMessage id='CANCEL' />
          </Button>
        </ButtonGroup>
      </ViewBody>
    </LeftSidebarView>
  )
}

export default withLeftSidebar(AddUserGroup)